import BoloesList from "./boloes/BoloesList";

export default function Boloes() {
  return <BoloesList />;
}